import React, { memo } from 'react';

import AssetOwnersFilter from '@components/Map/MapControls/Controls/AssetOwnersFilter';
import AssetsFilters from '@components/Map/MapControls/Controls/Filters/AssetsFilters/AssetsFilters';
import SitesFilters from '@components/Map/MapControls/Controls/Filters/Sites';
import VendorsFilter from '@components/Map/MapControls/Controls/Filters/VendorsFilter';

import { map } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

import { EDataType } from '@enums/map';

export const EFilterType = {
	owners: 'owners',
	attributes: 'attributes',
} as const;

export type TFilterType = TValueOfStringRecord<typeof EFilterType>

interface IGeneralFiltersProps {
	type: TFilterType;
}

const GeneralFilters = ({ type }: IGeneralFiltersProps) => {
	const { markerType } = useAppSelector(map);

	const isAssetsMode = markerType === EDataType.assets;

	return (isAssetsMode
			? type === EFilterType.owners
				? <AssetOwnersFilter />
				: <AssetsFilters />
			: type === EFilterType.owners
				? <VendorsFilter />
				: <SitesFilters />
	);
};

export default memo(GeneralFilters);
